import { render } from "./errorPage2.vue?vue&type=template&id=0d1b159c&scoped=true"
const script = {}

import "./errorPage2.vue?vue&type=style&index=0&id=0d1b159c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1b159c"]])

export default __exports__